const NOFOLLOW_ROUTES = [
  /^\/blog\/admin(?:\/|$)/,
  /^\/blog\/subscribe\/verify\/[^/]+\/?$/,
  /^\/blog\/unsubscribe\/[^/]+\/?$/,
  /^\/blog\/preferences\/?$/,
  /^\/(?:reset-password|verify-email)\/?$/
]

const FOLLOW_ROUTES = [
  /^\/(?:login|signup|forgot-password)\/?$/,
  /^\/blog\/(?:search|reading-list)\/?$/
]

export function getRouteRobotsDirective(pathname) {
  if (NOFOLLOW_ROUTES.some(pattern => pattern.test(pathname))) {
    return 'noindex,nofollow'
  }

  if (FOLLOW_ROUTES.some(pattern => pattern.test(pathname))) {
    return 'noindex,follow'
  }

  return null
}
